import { useMarketingPagesTracking } from "../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../tracking/GoogleTagManager/GoogleTagManagerScript";
import { AnalyticsMarketingPageLayout } from "../../pagelayouts/features/analytics";

const Analyze = () => {
    useMarketingPagesTracking(true);

    return (
        <>
            <GoogleTagManagerScript />
            <AnalyticsMarketingPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Analyze;
